export const ruleOptions = [
    {
        step: 'bureau_fraud_occurrences',
        name: 'Consulta de fraudes em Bureau',
        description: 'Classificação de risco de fraude do assinante encontrada em Bureau é igual ou superior ao nível configurado.',
        type: 'risk_level'
    },
    {
        step: 'politically_exposed_person',
        name: 'Pessoa Politicamente Exposta (PEP)',
        description: 'Assinante identificado como Pessoa Politicamente Exposta.',
        type: 'boolean'
    },
    {
        step: 'arrest_warrant',
        name: 'Mandado de prisão',
        description: 'Assinante possui mandado de prisão.',
        type: 'boolean'
    },
    {
        step: 'receita_federal_status',
        name: 'Situação cadastral na Receita Federal',
        description: 'CPF do assinante não está em situação regular na Receita Federal.',
        type: 'boolean'
    },
    {
        step: 'liveness',
        name: 'Liveness',
        description: 'Assinante foi identificado como fraudador na etapa de liveness.',
        type: 'boolean'
    },
    {
        step: 'fraud_face_matches',
        name: 'Banco de fraudes',
        description: 'Assinante possui face encontrada no banco de fraudes.',
        type: 'boolean'
    },
    {
        step: 'brazil_geolocation',
        name: 'Assinatura fora do Brasil',
        description: 'Processo de assinatura não foi feita no Brasil.',
        type: 'boolean'
    },
    {
        step: 'device_key_blocklist',
        name: 'Lista de dispositivos bloqueados',
        description: 'Lista de dispositivos bloqueados.',
        type: 'boolean'
    },    
    {    
        step: 'same_ip_different_document_numbers',
        name: 'Mesmo IP com diferentes CPFs',
        description: 'Se existirem outros processos de assinaturas no mesmo IP para número de documentos diferentes nos últimos 3 dias.',
        type: 'boolean'
    },
    {
        step: 'facematch_document',
        name: 'Grau de similaridade com documento',
        description: 'Pontuação de checagem de simlaridade de face com documento - OCR.',
        type: 'numeric'
    },
    {
        step: 'face_validation',
        name: 'Score de validação de face',
        description: 'Pontuação de validação de face',
        type: 'numeric'
    },
    {
        step: 'liveness_flags',
        name: 'Liveness - Indicadores',
        description: 'Lista de indicadores detectados durante a etapa de liveness.',
        type: 'list_presence'
    },
    {
        step: 'ocr_flags',
        name: 'OCR - Indicadores',
        description: 'Lista de indicadores detectados durante a etapa de OCR.',
        type: 'list_presence'
    },
    {
        step: 'face_validation_document_fallback',
        name: 'Revalidação de biometria por documento',
        description: 'Quando o score de validação de face fica na faixa inconclusiva, a biometria é comparada com a foto do documento pessoal enviado pelo assinante, desde que os indicadores de OCR estejam nos estados exigidos.',
        type: 'composite'
    },
    {
        step: 'basic_data_cross_check',
        name: 'Cruzamento de dados básicos',
        description: 'Compara os dados do assinante entre a proposta, o documento enviado e a base de dados, com uma decisão para divergência e outra para dado faltante em cada campo.',
        type: 'cross_check'
    },
    {
        step: 'fraudulent_document',
        name: 'Documento fraudado',
        description: 'Documento enviado pelo assinante foi identificado como fraudado.',
        type: 'boolean'
    },
    {
        step: 'document_fraud_indicators',
        name: 'Documento com indícios de fraude',
        description: 'Documento enviado pelo assinante apresenta indícios de fraude.',
        type: 'boolean'
    }
];

export const ocrFlags = [
    {
        value: 'found_illeterate_person_text',
        name: 'Pessoa analfabeta detectada pelo texto do documento'
    },
    {
        value: 'document_edges_issue',
        name: 'Parte do documento ocultada (rodapé, cabeçalho, bordas)'
    },
    {
        value: 'has_physical_damage',
        name: 'Documento apresenta danos físicos'
    },
    {
        value: 'has_textual_legibility_issues',
        name: 'Documento apresenta problemas de ilegilibilidade'
    },
    {
        value: 'document_tampering',
        name: 'Documento ou foto facial com traços de adulteração'
    },
    {
        value: 'screen_display_detected',
        name: 'Documento exibido em uma tela '
    },
    {
        value: 'is_copy',
        name: 'Documento é uma cópia (xerox ou impressão)'
    },
    {
        value: 'found_anomalous_pdf_creator_or_producer',
        name: 'Criador ou produtor do PDF é incomum'
    },
    {
        value: 'creation_and_modification_date_mismatch',
        name: 'Data de criação e modificação do PDF são diferentes'
    },
    {
        value: 'cpf_signer_mismatch',
        name: 'CPF do assinante divergente do documento'
    }
]

export const livenessFlags = [
    {
        value: 'multiple_people',
        name: 'Múltiplas pessoas detectadas na sessão de liveness'
    }
]

export const riskClassificationLevels = [
    {
        value: 'LOW',
        name: 'Baixo'
    },
    {
        value: 'MEDIUM',
        name: 'Médio'
    },
    {
        value: 'HIGH',
        name: 'Alto'
    },
    {
        value: 'VERY_HIGH',
        name: 'Muito alto'
    }
]

export const DEFAULT_RISK_CLASSIFICATION_LEVEL = 'MEDIUM'

export const mapRuleNameByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.name ?? 'Not mapped rule name'
}

export const mapRuleTypeByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.type ?? ''
}

export const mapFlagName = (flag) => {
    switch (flag) {
        case 'found_illeterate_person_text':
            return 'Pessoa analfabeta'
        case 'multiple_people':
            return 'Múltiplas pessoas'
        case 'document_edges_issue':
            return 'Parte do documento foi ocultada'
        case 'found_state_text':
            return 'Encontrou estado'
        case 'found_footer_text':
            return 'Encontrou rodapé'
        case 'found_header_text':
            return 'Encontrou cabeçalho'
        case 'all_edges_detected':
            return 'Possível ocultação de contorno'
        case 'found_side_text':
            return 'Encontrou texto lateral'
        case 'screen_display_detected':
            return 'Documento exibido em uma tela'
        case 'is_copy':
            return 'Documento é uma cópia (xerox ou impressão)'
        case 'text_tampering_detected':
            return 'Adulteração de conteúdo'
        case 'face_tampering_detected':
            return 'Foto facial adulterada'
        case 'has_physical_damage':
            return 'Documento apresenta danos físicos'
        case 'has_textual_legibility_issues':
            return 'Problemas de legibilidade'
        case 'document_tampering':
            return 'Documento ou foto facial com traços de adulteração'
        case 'found_anomalous_pdf_creator_or_producer':
            return 'Criador ou produtor do PDF é incomum'
        case 'creation_and_modification_date_mismatch':
            return 'Data de criação e modificação do PDF são diferentes'
        case 'cpf_signer_mismatch':
            return 'CPF do assinante divergente do documento'
        default:
            return 'Indicador não mapeado'
    }
}

export const mapRiskClassificationName = (level) => {
    switch (level) {
        case 'LOW':
            return 'Baixo'
        case 'MEDIUM':
            return 'Médio'
        case 'HIGH':
            return 'Alto'
        case 'VERY_HIGH':
            return 'Muito alto'
        default:
            return 'Nível de risco não mapeado'
    }
}

export const mapRuleDecisionByStep = (step) => {
    let rule = ruleOptions.find(rule => rule.step === step)
    return rule?.description ?? 'Not mapped rule description'
}


export const repprovementDecisions = [
    {
        value: 'reproved',
        name: 'Reprovar'
    },
    {
        value: 'in_manual_analysis',
        name: 'Análise manual'
    }
]

export const mapRuleDecisionName = (decision) => {
    let decisionFound = repprovementDecisions.find(rule => rule.value === decision)
    return decisionFound?.name ?? 'Not mapped decision name'
}

export const fallbackDecisions = [
    {
        value: 'approved',
        name: 'Aprovar'
    },
    {
        value: 'in_manual_analysis',
        name: 'Análise manual'
    }
]

export const floorComparisonTypes = [
    {
        value: 'greater_or_equal',
        name: 'inclui o valor'
    },
    {
        value: 'greater',
        name: 'exclui o valor'
    }
]

export const ceilingComparisonTypes = [
    {
        value: 'less_or_equal',
        name: 'inclui o valor'
    },
    {
        value: 'less',
        name: 'exclui o valor'
    }
]

export const documentComparisonTypes = [
    {
        value: 'less_or_equal',
        name: 'maior que o valor'
    },
    {
        value: 'less',
        name: 'maior ou igual ao valor'
    }
]

export const expectedFlagStates = [
    {
        value: 'true',
        name: 'Sim'
    },
    {
        value: 'false',
        name: 'Não'
    }
]

export const DEFAULT_INCONCLUSIVE_FLOOR = '50'
export const DEFAULT_INCONCLUSIVE_CEILING = '60'
export const DEFAULT_DOCUMENT_SIMILARITY_THRESHOLD = '80'
export const DEFAULT_FLOOR_COMPARISON_TYPE = 'greater_or_equal'
export const DEFAULT_CEILING_COMPARISON_TYPE = 'less_or_equal'
export const DEFAULT_DOCUMENT_COMPARISON_TYPE = 'less_or_equal'
export const DEFAULT_FALLBACK_DECISION = 'approved'

export const mapFallbackDecisionName = (decision) => {
    let decisionFound = fallbackDecisions.find(item => item.value === decision)
    return decisionFound?.name ?? 'Not mapped decision name'
}

export const crossCheckFields = [
    {
        value: 'cpf',
        name: 'CPF',
        sources: ['Proposta', 'Documento'],
        appliesTo: 'RG e CNH'
    },
    // {
    //     value: 'name',
    //     name: 'Nome',
    //     sources: ['Proposta', 'Documento', 'Base'],
    //     appliesTo: 'RG e CNH'
    // },
    {
        value: 'birthdate',
        name: 'Data de nascimento',
        sources: ['Proposta', 'Documento', 'Base'],
        appliesTo: 'RG e CNH'
    },
    // {
    //     value: 'mother_name',
    //     name: 'Nome da mãe',
    //     sources: ['Documento', 'Base'],
    //     appliesTo: 'RG e CNH'
    // },
    // {
    //     value: 'father_name',
    //     name: 'Nome do pai',
    //     sources: ['Documento', 'Base'],
    //     appliesTo: 'RG e CNH'
    // },
    // {
    //     value: 'place_of_birth',
    //     name: 'Naturalidade (UF)',
    //     sources: ['Documento', 'Base'],
    //     appliesTo: 'Apenas RG'
    // }
]

export const crossCheckMissingDataDecisions = [
    {
        value: 'ignore',
        name: 'Ignorar'
    },
    {
        value: 'in_manual_analysis',
        name: 'Análise manual'
    },
    {
        value: 'reproved',
        name: 'Reprovar'
    }
]

export const DEFAULT_CROSS_CHECK_DECISION = 'in_manual_analysis'
export const DEFAULT_CROSS_CHECK_MISSING_DATA_DECISION = 'in_manual_analysis'

const crossCheckFieldNames = {
    cpf: 'CPF',
    name: 'Nome',
    birthdate: 'Data de nascimento',
    mother_name: 'Nome da mãe',
    father_name: 'Nome do pai',
    place_of_birth: 'Naturalidade (UF)'
}

export const mapCrossCheckFieldName = (field) => {
    return crossCheckFieldNames[field] ?? 'Campo não mapeado'
}

export const mapCrossCheckSourceName = (source) => {
    switch (source) {
        case 'proposal':
            return 'Proposta'
        case 'document':
            return 'Documento'
        case 'bureau':
            return 'Base'
        default:
            return source
    }
}

export const describeCrossCheckResult = (crossCheckResult) => {
    if (crossCheckResult.result === 'matched') {
        const comparedSources = (crossCheckResult.sources || []).map(mapCrossCheckSourceName)
        return `confere entre ${comparedSources.join(' × ')}`
    }

    if (crossCheckResult.result === 'missing') {
        const missingSources = (crossCheckResult.sources || []).map(mapCrossCheckSourceName)
        return `dado faltante em ${missingSources.join(' e ')}`
    }

    const mismatchedPairs = crossCheckResult.mismatched_pairs || [crossCheckResult.sources || []]
    const pairNames = mismatchedPairs.map((pair) => pair.map(mapCrossCheckSourceName).join(' × '))
    return `divergência entre ${pairNames.join(', ')}`
}

export const mapCrossCheckMissingDataDecisionName = (decision) => {
    let decisionFound = crossCheckMissingDataDecisions.find(item => item.value === decision)
    return decisionFound?.name ?? 'Not mapped decision name'
}

export const mapRangeEdgeName = (comparisonType) => {
    switch (comparisonType) {
        case 'greater_or_equal':
            return 'inclusivo'
        case 'less_or_equal':
            return 'inclusivo'
        case 'greater':
            return 'exclusivo'
        case 'less':
            return 'exclusivo'
        default:
            return 'inclusivo'
    }
}

export const mapDocumentComparisonName = (comparisonType) => {
    switch (comparisonType) {
        case 'less':
            return 'maior ou igual a'
        default:
            return 'maior que'
    }
}

export const mapExpectedFlagStateName = (expected) => {
    if (expected) {
        return 'precisa estar presente'
    }
    return 'precisa estar ausente'
}

export const ATOMIC_OCR_FLAG_VALUES = [
    'found_illeterate_person_text',
    'has_physical_damage',
    'has_textual_legibility_issues',
    'screen_display_detected',
    'found_anomalous_pdf_creator_or_producer',
    'creation_and_modification_date_mismatch',
    'found_state_text',
    'found_footer_text',
    'found_header_text',
    'found_side_text',
    'all_edges_detected',
    'text_tampering_detected',
    'face_tampering_detected',
    'cpf_signer_mismatch'
]

export const ocrAtomicFlags = ATOMIC_OCR_FLAG_VALUES.map((flag) => ({ value: flag, name: mapFlagName(flag) }))

export const isAtomicOcrFlag = (flag) => {
    return ATOMIC_OCR_FLAG_VALUES.includes(flag)
}

export const mapAtomicFlagName = (flag) => {
    return mapFlagName(flag)
}




